import { render, staticRenderFns } from "./sincerityPayMent.vue?vue&type=template&id=445ae704&scoped=true"
import script from "./sincerityPayMent.vue?vue&type=script&lang=js"
export * from "./sincerityPayMent.vue?vue&type=script&lang=js"
import style0 from "./sincerityPayMent.vue?vue&type=style&index=0&id=445ae704&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ae704",
  null
  
)

export default component.exports